(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var captureStack = kotlin_kotlin.$_$.p8;
  var getStringHashCode = kotlin_kotlin.$_$.c9;
  var THROW_CCE = kotlin_kotlin.$_$.vc;
  var classMeta = kotlin_kotlin.$_$.v8;
  var RuntimeException = kotlin_kotlin.$_$.uc;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.k2;
  //endregion
  //region block: pre-declaration
  ApiException.prototype = Object.create(RuntimeException.prototype);
  ApiException.prototype.constructor = ApiException;
  Client.prototype = Object.create(ApiException.prototype);
  Client.prototype.constructor = Client;
  BadRequest.prototype = Object.create(Client.prototype);
  BadRequest.prototype.constructor = BadRequest;
  Unauthorized.prototype = Object.create(Client.prototype);
  Unauthorized.prototype.constructor = Unauthorized;
  Forbidden.prototype = Object.create(Client.prototype);
  Forbidden.prototype.constructor = Forbidden;
  NotFound.prototype = Object.create(Client.prototype);
  NotFound.prototype.constructor = NotFound;
  Conflict.prototype = Object.create(Client.prototype);
  Conflict.prototype.constructor = Conflict;
  General.prototype = Object.create(Client.prototype);
  General.prototype.constructor = General;
  Server.prototype = Object.create(ApiException.prototype);
  Server.prototype.constructor = Server;
  Connection.prototype = Object.create(ApiException.prototype);
  Connection.prototype.constructor = Connection;
  General_0.prototype = Object.create(ApiException.prototype);
  General_0.prototype.constructor = General_0;
  //endregion
  function BadRequest(errorCode, message) {
    Client.call(this, 400, errorCode, message);
    this.xk_1 = errorCode;
    this.yk_1 = message;
    captureStack(this, BadRequest);
  }
  BadRequest.prototype.zk = function () {
    return this.xk_1;
  };
  BadRequest.prototype.n1 = function () {
    return this.yk_1;
  };
  BadRequest.prototype.component1 = function () {
    return this.xk_1;
  };
  BadRequest.prototype.component2 = function () {
    return this.yk_1;
  };
  BadRequest.prototype.copy = function (errorCode, message) {
    return this.al(errorCode === void 1 ? this.xk_1 : errorCode, message === void 1 ? this.yk_1 : message);
  };
  BadRequest.prototype.al = function (errorCode, message) {
    return new BadRequest(errorCode, message);
  };
  BadRequest.prototype.bl = function (errorCode, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      errorCode = this.xk_1;
    if (!(($mask0 & 2) === 0))
      message = this.yk_1;
    return this.al(errorCode, message);
  };
  BadRequest.prototype.toString = function () {
    return 'BadRequest(errorCode=' + this.xk_1 + ', message=' + this.yk_1 + ')';
  };
  BadRequest.prototype.hashCode = function () {
    var result = getStringHashCode(this.xk_1);
    result = imul(result, 31) + getStringHashCode(this.yk_1) | 0;
    return result;
  };
  BadRequest.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BadRequest))
      return false;
    var tmp0_other_with_cast = other instanceof BadRequest ? other : THROW_CCE();
    if (!(this.xk_1 === tmp0_other_with_cast.xk_1))
      return false;
    if (!(this.yk_1 === tmp0_other_with_cast.yk_1))
      return false;
    return true;
  };
  BadRequest.$metadata$ = classMeta('BadRequest', undefined, undefined, undefined, undefined, Client.prototype);
  Object.defineProperty(BadRequest.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function Unauthorized(errorCode, message) {
    Client.call(this, 401, errorCode, message);
    this.ll_1 = errorCode;
    this.ml_1 = message;
    captureStack(this, Unauthorized);
  }
  Unauthorized.prototype.zk = function () {
    return this.ll_1;
  };
  Unauthorized.prototype.n1 = function () {
    return this.ml_1;
  };
  Unauthorized.prototype.component1 = function () {
    return this.ll_1;
  };
  Unauthorized.prototype.component2 = function () {
    return this.ml_1;
  };
  Unauthorized.prototype.copy = function (errorCode, message) {
    return this.al(errorCode === void 1 ? this.ll_1 : errorCode, message === void 1 ? this.ml_1 : message);
  };
  Unauthorized.prototype.al = function (errorCode, message) {
    return new Unauthorized(errorCode, message);
  };
  Unauthorized.prototype.bl = function (errorCode, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      errorCode = this.ll_1;
    if (!(($mask0 & 2) === 0))
      message = this.ml_1;
    return this.al(errorCode, message);
  };
  Unauthorized.prototype.toString = function () {
    return 'Unauthorized(errorCode=' + this.ll_1 + ', message=' + this.ml_1 + ')';
  };
  Unauthorized.prototype.hashCode = function () {
    var result = getStringHashCode(this.ll_1);
    result = imul(result, 31) + getStringHashCode(this.ml_1) | 0;
    return result;
  };
  Unauthorized.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Unauthorized))
      return false;
    var tmp0_other_with_cast = other instanceof Unauthorized ? other : THROW_CCE();
    if (!(this.ll_1 === tmp0_other_with_cast.ll_1))
      return false;
    if (!(this.ml_1 === tmp0_other_with_cast.ml_1))
      return false;
    return true;
  };
  Unauthorized.$metadata$ = classMeta('Unauthorized', undefined, undefined, undefined, undefined, Client.prototype);
  Object.defineProperty(Unauthorized.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function Forbidden(errorCode, message) {
    Client.call(this, 403, errorCode, message);
    this.rl_1 = errorCode;
    this.sl_1 = message;
    captureStack(this, Forbidden);
  }
  Forbidden.prototype.zk = function () {
    return this.rl_1;
  };
  Forbidden.prototype.n1 = function () {
    return this.sl_1;
  };
  Forbidden.prototype.component1 = function () {
    return this.rl_1;
  };
  Forbidden.prototype.component2 = function () {
    return this.sl_1;
  };
  Forbidden.prototype.copy = function (errorCode, message) {
    return this.al(errorCode === void 1 ? this.rl_1 : errorCode, message === void 1 ? this.sl_1 : message);
  };
  Forbidden.prototype.al = function (errorCode, message) {
    return new Forbidden(errorCode, message);
  };
  Forbidden.prototype.bl = function (errorCode, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      errorCode = this.rl_1;
    if (!(($mask0 & 2) === 0))
      message = this.sl_1;
    return this.al(errorCode, message);
  };
  Forbidden.prototype.toString = function () {
    return 'Forbidden(errorCode=' + this.rl_1 + ', message=' + this.sl_1 + ')';
  };
  Forbidden.prototype.hashCode = function () {
    var result = getStringHashCode(this.rl_1);
    result = imul(result, 31) + getStringHashCode(this.sl_1) | 0;
    return result;
  };
  Forbidden.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Forbidden))
      return false;
    var tmp0_other_with_cast = other instanceof Forbidden ? other : THROW_CCE();
    if (!(this.rl_1 === tmp0_other_with_cast.rl_1))
      return false;
    if (!(this.sl_1 === tmp0_other_with_cast.sl_1))
      return false;
    return true;
  };
  Forbidden.$metadata$ = classMeta('Forbidden', undefined, undefined, undefined, undefined, Client.prototype);
  Object.defineProperty(Forbidden.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function NotFound(errorCode, message) {
    Client.call(this, 404, errorCode, message);
    this.xl_1 = errorCode;
    this.yl_1 = message;
    captureStack(this, NotFound);
  }
  NotFound.prototype.zk = function () {
    return this.xl_1;
  };
  NotFound.prototype.n1 = function () {
    return this.yl_1;
  };
  NotFound.prototype.component1 = function () {
    return this.xl_1;
  };
  NotFound.prototype.component2 = function () {
    return this.yl_1;
  };
  NotFound.prototype.copy = function (errorCode, message) {
    return this.al(errorCode === void 1 ? this.xl_1 : errorCode, message === void 1 ? this.yl_1 : message);
  };
  NotFound.prototype.al = function (errorCode, message) {
    return new NotFound(errorCode, message);
  };
  NotFound.prototype.bl = function (errorCode, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      errorCode = this.xl_1;
    if (!(($mask0 & 2) === 0))
      message = this.yl_1;
    return this.al(errorCode, message);
  };
  NotFound.prototype.toString = function () {
    return 'NotFound(errorCode=' + this.xl_1 + ', message=' + this.yl_1 + ')';
  };
  NotFound.prototype.hashCode = function () {
    var result = getStringHashCode(this.xl_1);
    result = imul(result, 31) + getStringHashCode(this.yl_1) | 0;
    return result;
  };
  NotFound.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NotFound))
      return false;
    var tmp0_other_with_cast = other instanceof NotFound ? other : THROW_CCE();
    if (!(this.xl_1 === tmp0_other_with_cast.xl_1))
      return false;
    if (!(this.yl_1 === tmp0_other_with_cast.yl_1))
      return false;
    return true;
  };
  NotFound.$metadata$ = classMeta('NotFound', undefined, undefined, undefined, undefined, Client.prototype);
  Object.defineProperty(NotFound.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function Conflict(errorCode, message) {
    Client.call(this, 409, errorCode, message);
    this.dm_1 = errorCode;
    this.em_1 = message;
    captureStack(this, Conflict);
  }
  Conflict.prototype.zk = function () {
    return this.dm_1;
  };
  Conflict.prototype.n1 = function () {
    return this.em_1;
  };
  Conflict.prototype.component1 = function () {
    return this.dm_1;
  };
  Conflict.prototype.component2 = function () {
    return this.em_1;
  };
  Conflict.prototype.copy = function (errorCode, message) {
    return this.al(errorCode === void 1 ? this.dm_1 : errorCode, message === void 1 ? this.em_1 : message);
  };
  Conflict.prototype.al = function (errorCode, message) {
    return new Conflict(errorCode, message);
  };
  Conflict.prototype.bl = function (errorCode, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      errorCode = this.dm_1;
    if (!(($mask0 & 2) === 0))
      message = this.em_1;
    return this.al(errorCode, message);
  };
  Conflict.prototype.toString = function () {
    return 'Conflict(errorCode=' + this.dm_1 + ', message=' + this.em_1 + ')';
  };
  Conflict.prototype.hashCode = function () {
    var result = getStringHashCode(this.dm_1);
    result = imul(result, 31) + getStringHashCode(this.em_1) | 0;
    return result;
  };
  Conflict.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Conflict))
      return false;
    var tmp0_other_with_cast = other instanceof Conflict ? other : THROW_CCE();
    if (!(this.dm_1 === tmp0_other_with_cast.dm_1))
      return false;
    if (!(this.em_1 === tmp0_other_with_cast.em_1))
      return false;
    return true;
  };
  Conflict.$metadata$ = classMeta('Conflict', undefined, undefined, undefined, undefined, Client.prototype);
  Object.defineProperty(Conflict.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function General(statusCode, message) {
    Client.call(this, statusCode, '', message);
    this.jm_1 = statusCode;
    this.km_1 = message;
    captureStack(this, General);
  }
  General.prototype.gl = function () {
    return this.jm_1;
  };
  General.prototype.n1 = function () {
    return this.km_1;
  };
  General.prototype.component1 = function () {
    return this.jm_1;
  };
  General.prototype.component2 = function () {
    return this.km_1;
  };
  General.prototype.copy = function (statusCode, message) {
    return this.lm(statusCode === void 1 ? this.jm_1 : statusCode, message === void 1 ? this.km_1 : message);
  };
  General.prototype.lm = function (statusCode, message) {
    return new General(statusCode, message);
  };
  General.prototype.mm = function (statusCode, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      statusCode = this.jm_1;
    if (!(($mask0 & 2) === 0))
      message = this.km_1;
    return this.lm(statusCode, message);
  };
  General.prototype.toString = function () {
    return 'General(statusCode=' + this.jm_1 + ', message=' + this.km_1 + ')';
  };
  General.prototype.hashCode = function () {
    var result = this.jm_1;
    result = imul(result, 31) + getStringHashCode(this.km_1) | 0;
    return result;
  };
  General.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof General))
      return false;
    var tmp0_other_with_cast = other instanceof General ? other : THROW_CCE();
    if (!(this.jm_1 === tmp0_other_with_cast.jm_1))
      return false;
    if (!(this.km_1 === tmp0_other_with_cast.km_1))
      return false;
    return true;
  };
  General.$metadata$ = classMeta('General', undefined, undefined, undefined, undefined, Client.prototype);
  Object.defineProperty(General.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function Client(statusCode, errorCode, message) {
    ApiException.call(this, message);
    this.dl_1 = statusCode;
    this.el_1 = errorCode;
    this.fl_1 = message;
    captureStack(this, Client);
  }
  Client.prototype.gl = function () {
    return this.dl_1;
  };
  Client.prototype.zk = function () {
    return this.el_1;
  };
  Client.prototype.n1 = function () {
    return this.fl_1;
  };
  Client.$metadata$ = classMeta('Client', undefined, undefined, undefined, undefined, ApiException.prototype);
  Object.defineProperty(Client.prototype, 'statusCode', {
    configurable: true,
    get: function () {
      return this.gl();
    }
  });
  Object.defineProperty(Client.prototype, 'errorCode', {
    configurable: true,
    get: function () {
      return this.zk();
    }
  });
  Object.defineProperty(Client.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function Server(message) {
    ApiException.call(this, message);
    this.om_1 = message;
    captureStack(this, Server);
  }
  Server.prototype.n1 = function () {
    return this.om_1;
  };
  Server.prototype.component1 = function () {
    return this.om_1;
  };
  Server.prototype.copy = function (message) {
    return this.pm(message === void 1 ? this.om_1 : message);
  };
  Server.prototype.pm = function (message) {
    return new Server(message);
  };
  Server.prototype.qm = function (message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = this.om_1;
    return this.pm(message);
  };
  Server.prototype.toString = function () {
    return 'Server(message=' + this.om_1 + ')';
  };
  Server.prototype.hashCode = function () {
    return getStringHashCode(this.om_1);
  };
  Server.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Server))
      return false;
    var tmp0_other_with_cast = other instanceof Server ? other : THROW_CCE();
    if (!(this.om_1 === tmp0_other_with_cast.om_1))
      return false;
    return true;
  };
  Server.$metadata$ = classMeta('Server', undefined, undefined, undefined, undefined, ApiException.prototype);
  Object.defineProperty(Server.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function Connection(message) {
    ApiException.call(this, message);
    this.sm_1 = message;
    captureStack(this, Connection);
  }
  Connection.prototype.n1 = function () {
    return this.sm_1;
  };
  Connection.prototype.component1 = function () {
    return this.sm_1;
  };
  Connection.prototype.copy = function (message) {
    return this.tm(message === void 1 ? this.sm_1 : message);
  };
  Connection.prototype.tm = function (message) {
    return new Connection(message);
  };
  Connection.prototype.qm = function (message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = this.sm_1;
    return this.tm(message);
  };
  Connection.prototype.toString = function () {
    return 'Connection(message=' + this.sm_1 + ')';
  };
  Connection.prototype.hashCode = function () {
    return this.sm_1 == null ? 0 : getStringHashCode(this.sm_1);
  };
  Connection.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Connection))
      return false;
    var tmp0_other_with_cast = other instanceof Connection ? other : THROW_CCE();
    if (!(this.sm_1 == tmp0_other_with_cast.sm_1))
      return false;
    return true;
  };
  Connection.$metadata$ = classMeta('Connection', undefined, undefined, undefined, undefined, ApiException.prototype);
  Object.defineProperty(Connection.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function General_0(message) {
    ApiException.call(this, message);
    this.vm_1 = message;
    captureStack(this, General_0);
  }
  General_0.prototype.n1 = function () {
    return this.vm_1;
  };
  General_0.prototype.component1 = function () {
    return this.vm_1;
  };
  General_0.prototype.copy = function (message) {
    return this.tm(message === void 1 ? this.vm_1 : message);
  };
  General_0.prototype.tm = function (message) {
    return new General_0(message);
  };
  General_0.prototype.qm = function (message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = this.vm_1;
    return this.tm(message);
  };
  General_0.prototype.toString = function () {
    return 'General(message=' + this.vm_1 + ')';
  };
  General_0.prototype.hashCode = function () {
    return this.vm_1 == null ? 0 : getStringHashCode(this.vm_1);
  };
  General_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof General_0))
      return false;
    var tmp0_other_with_cast = other instanceof General_0 ? other : THROW_CCE();
    if (!(this.vm_1 == tmp0_other_with_cast.vm_1))
      return false;
    return true;
  };
  General_0.$metadata$ = classMeta('General', undefined, undefined, undefined, undefined, ApiException.prototype);
  Object.defineProperty(General_0.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  function ApiException(message) {
    RuntimeException_init_$Init$(message, this);
    this.wm_1 = message;
    captureStack(this, ApiException);
  }
  ApiException.prototype.n1 = function () {
    return this.wm_1;
  };
  ApiException.$metadata$ = classMeta('ApiException', undefined, undefined, undefined, undefined, RuntimeException.prototype);
  Object.defineProperty(ApiException.prototype, 'message', {
    configurable: true,
    get: function () {
      return this.n1();
    }
  });
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$taager = $com.taager || ($com.taager = {});
    var $com$taager$experience = $com$taager.experience || ($com$taager.experience = {});
    var $com$taager$experience$data = $com$taager$experience.data || ($com$taager$experience.data = {});
    var $com$taager$experience$data$exception = $com$taager$experience$data.exception || ($com$taager$experience$data.exception = {});
    $com$taager$experience$data$exception.ApiException = ApiException;
    $com$taager$experience$data$exception.ApiException.Client = Client;
    $com$taager$experience$data$exception.ApiException.Client.BadRequest = BadRequest;
    $com$taager$experience$data$exception.ApiException.Client.Unauthorized = Unauthorized;
    $com$taager$experience$data$exception.ApiException.Client.Forbidden = Forbidden;
    $com$taager$experience$data$exception.ApiException.Client.NotFound = NotFound;
    $com$taager$experience$data$exception.ApiException.Client.Conflict = Conflict;
    $com$taager$experience$data$exception.ApiException.Client.General = General;
    $com$taager$experience$data$exception.ApiException.Server = Server;
    $com$taager$experience$data$exception.ApiException.Connection = Connection;
    $com$taager$experience$data$exception.ApiException.General = General_0;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = BadRequest;
  _.$_$.b = Conflict;
  _.$_$.c = Forbidden;
  _.$_$.d = General;
  _.$_$.e = NotFound;
  _.$_$.f = Unauthorized;
  _.$_$.g = Connection;
  _.$_$.h = General_0;
  _.$_$.i = Server;
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js')));

